import { Pipe, PipeTransform } from '@angular/core';

import { Feature } from '@vi-iot/client';

@Pipe({
  name: 'error',
})
export class ErrorPipe implements PipeTransform {
  transform(feature: Feature<unknown, unknown>): boolean {
    return !!(
      feature &&
      feature.properties &&
      feature.properties['status'] &&
      feature.properties['status'].value === 'error'
    );
  }
}
